import { boolean, object, string } from "zod";

export const getWayfairIntegration = {
  name: "getWayfairIntegration" as const,
  input: object({}),
  output: object({
    wayfairIntegration: object({
      clientId: string(),
      isConnected: boolean(),
    }).optional(),
  }),
};
